class Exception extends Error {
  constructor(message: string) {
    super(message);
    this.name = this.constructor.name;
  }
}

export default Exception;
